export const Speciality = Object.freeze({
  JuniorNurse: 288
})